var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),_c('Search',{attrs:{"msg":_vm.$t('floatNav.Account')}}),_c('div',{staticClass:"con w-1920"},[_c('div',{staticClass:"center w-1200"},[_c('Left_menu'),_c('router-view')],1)]),_c('div',{staticClass:"kongbai"}),_c('Foot'),_c('Cart')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }